import React from 'react'
import PropTypes from 'prop-types'

const OrderPointsAndCash = props => {
  return props.paymentDetailMoneyAndPoints &&
    props.paymentDetailMoneyAndPoints.isDisplay ? (
      <div className='row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'>
        <div className='col-3 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '>
          <img
            className='w-100'
            src={props.paymentDetailMoneyAndPoints.imageUrlCardBrand}
            alt='Bandeiras da operadora do cartão de crédito'
          />
        </div>
        <div className='col-9  txt-left  justify-content-center align-self-center'>
          <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
          Cartão:
            <strong>
            XXXX-XXXX-XXXX-
              {props.paymentDetailMoneyAndPoints.lastCreditCardDigits}
            </strong>
          </p>

          <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
          Valor:
            <strong>
              {props.paymentDetailMoneyAndPoints.numberParcels}x R$
              {props.paymentDetailMoneyAndPoints.valueParcel}
            </strong>
          </p>
        </div>
      </div>
    ) : (
      ''
    )
}
OrderPointsAndCash.propTypes = {
  paymentDetailMoneyAndPoints: PropTypes.object
}

export default OrderPointsAndCash



// WEBPACK FOOTER //
// ./src/features/AboutOrder/OrderPointsAndCash.js